import React from 'react'
import AdminHeader from './AdminHeader'
import MascotaProtegida from '../Usuario/MascotaProtegida'

const MascotasAdm = () => {
    return (
        <>
            <AdminHeader />
            <MascotaProtegida />
        </>
    )
}

export default MascotasAdm
